
@if(!universalService.isMobileDevice) {
  <lib-header />
}
<lib-toast/>
<div class="app-wrapper" >
  @if(universalService.iframeLogin){
    <app-global-access/>
  }
  <main role="main" class="main-wrapper">
      <div class="flex-container">
        <!-- First Column -->

        @if(universalService.isMobileDevice){
          <app-global-access/>
        }@else{
          @if(!universalService.iframeLogin){
            <div class="flex-item first-column">
              <app-global-access/>
            </div>
          }
        } 
          <!-- Second Column -->
          <div class="flex-item second-column">
            <div id="parent" [ngStyle]="{ 'width' : (universalService.isMobileDevice &&  this.router.url.includes('/teamfolder'))? '100%' : ''}">
              @if (!universalService.isMobileDevice) {
                  <div class="global-header pseudo-header" [ngStyle]="{ 'box-shadow' : universalService.showGlobalHeaderBottomBorder ? '0 15px 10px -15px #00000029' : ''}">
                    <!-- @if(this.router.url.includes('/home') && (userData.authProviderId == 2 || userData.authProviderId == 3 || userData.authProviderId == 5 || userData.authProviderId == 7 || ((userData.authProviderId == 4 || userData.authProviderId == 26)&& userData['eligibleForUpgrade'] == 'Y' && userData['quotaUpgraded'] == 'N'))) {
                      <common-user-communication />
                    } -->

                    <div class="row m-0 p-0" >
                      <div class="p-0" [ngClass]="(universalService.selectedTab == 'Album Details' || universalService.selectedTab == 'Albums') ? 'col-12': 'col-4'">
                        <app-file-operations-wrapper [headingTitle] = "'MyFiles'"/>
                      </div>
                    <!-- <div class="col-4 p-0">
                        <app-search [ngClass]="!universalService.showSearchBar ? 'hide': 'show'" class="search-box-cont"/>
                      </div> -->
                      <!-- <div class="col-4 p-0 usr-help-access-btn-cont"  [ngClass]="[universalService.selectedTab == 'Album Details' ? 'hide': '']">
                        <div class="btn-group dropdown">
                          <span class="NeueHelp usr-help-access-btn" data-toggle="dropdown"></span>
                          <div class="dropdown-menu">
                            <div class="uiBox">
                              <span class="NeueHelp"></span>
                            </div>
                            <a class="dropdown-item" href="javascript:void(0);" (click)="redirectTo('faq')" rel="noopener noreferrer">FAQs</a>
                            <a class="dropdown-item" href="javascript:void(0);" (click)="redirectTo('htv')" rel="noopener noreferrer">HOW TO VIDEOS</a>
                          </div>
                        </div>
                      </div> -->
                    </div>
                    @if (!universalService.inAppWebViewOpened) {
                      <app-tabbed-view [scrollToTopIcon]="universalService.scrollToTopIcon"/>
                    }
                    @if((universalService.openFolderContent || globalService.getFolderServiceRef().breadCrumbsList.length > 1) && !universalService.showBreadCrumbsInsideTabContent && universalService.viewContainsFolders) {
                      <lib-foldersview/>
                    }
                    @if(universalService.showWhatsSearchable && userData["simSearchTwoAi"].isSimTwoAiEnabled === "A" && userData["simSearchTwoAi"].isStatsTwoAiEnabled === "A") {
                      <common-sematic-search-status></common-sematic-search-status>
                    }
                  </div>
              }
        
              @if (universalService.isMobileDevice) {
                <div>
                  <app-file-operations-wrapper [headingTitle] = "'MyFiles'"/>
                  @if (!universalService.inAppWebViewOpened) {
                    <app-tabbed-view  [scrollToTopIcon]="universalService.scrollToTopIcon"/>
                  }
                  @if((universalService.openFolderContent || globalService.getFolderServiceRef().breadCrumbsList.length > 1)) {
                    <lib-foldersview/>
                  }
                </div>
              }
              <div class="tab-content" appGlobalUpload [attr.global-droppable]="!router.url.includes('home')" [ngClass]="universalService.isMobileDevice && router.url.includes('shared/') ? '' : 'mt-2' ">
                <!-- @if(universalService.isMobileDevice && this.router.url.includes('/home')  && (userData.authProviderId == 4 || userData.authProviderId == 26) && userData['eligibleForUpgrade'] == 'Y' && userData['quotaUpgraded'] == 'N') {
                  <common-user-communication />
                } -->
                <!-- @if(universalService.isMobileDevice){ -->
                  <common-user-communication />
                <!-- } -->
                @if (!router.url.includes('/buystorage') && !router.url.includes('/orderhistory')) {
                  <div class="banner-container pseudo-banner-container">
                    <!-- <refer-earn-banner /> -->
                    <!-- {{universalService.userHasCompletedOnBoardingFlow}} -->
                    @if (universalService.activeRepo == 'main' && !universalService.inAppWebViewOpened && universalService.userHasCompletedOnBoardingFlow) {
                      <app-email-verification/>
                    }
                    @if (universalService.currentTab != 'Profile' && universalService.currentTab != 'Search Results') {
                      <lib-banner/>
                    }
                    @if(this.enableSocialLogin){
                      <common-social-logindisable-banner />
                    }
                  </div>
                }
                @if (!universalService.inAppWebViewOpened && this.universalService.fullScreenBannerDetails  && this.universalService.fullScreenBannerDetails.cards.length > 0) {
                  <app-blocking-nonblocking-banner-modal/>
                }
                @if (this.universalService.showDowntimeBannerModal && !universalService.inAppWebViewOpened) {
                  <common-downtime-banner/>
                }
                @if((universalService.openFolderContent || globalService.getFolderServiceRef().breadCrumbsList.length > 1) && universalService.showBreadCrumbsInsideTabContent && universalService.viewContainsFolders && !universalService.isMobileDevice) {
                  <lib-foldersview/>
                }
                <router-outlet/>
              </div>
            </div>
          </div>

          <!-- Third Column -->
          <!-- <div class="flex-item third-column" style="border: solid 1px green">
          </div> -->
        
      </div>
  </main>
</div>

